import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    carouselTitle?:string;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
    
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;

            &.product-desc span{
                font-family: ProximaNova, Helvetica, Arial, sans-serif;
                font-weight: 700;
                font-size: .9875em;
                color: #1c3e95;

                &:hover{
                    text-decoration: underline;
                }

                .product-disc {
                    font-size: .75em;
                    font-weight: 600;
                    display: block;
                }
            }

            &.product-desc .model-num{
                color: #1c3e95;
                font-family: ProximaNova, Helvetica, Arial, sans-serif;
                font-size: .75em;
                font-weight: 600;
                &:hover{
                    text-decoration: underline;
                }
            }
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
};

const ProductDescription = ({ product, onClick, extendedStyles,carouselTitle }: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");

    const secondDescription = "product" in product ? "" : "properties" in product ? product.properties["secondDescription"] : "";
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const modelNumber = "product" in product ? product.product.detail?.modelNumber : "";

    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        <Link
            {...styles.productDetailLink}
            href={productDetailPath}
            alt={`See product details for ${description}`}
            onClick={onClick}
            data-test-selector="productDescriptionLink"
            className="product-desc"
        >
            <Typography as="span">{description}</Typography>
            <Typography as="span" className="product-disc">{secondDescription}</Typography>
            {/* {carouselTitle?.toLowerCase()!=="featured equipment" &&( 
               <Typography as="div" className="model-num">{modelNumber}
               </Typography>
            )} */}
           
        </Link>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}
         {/* {carouselTitle?.toLowerCase()!=="featured equipment" &&( 
               <Typography as="div" className="model-num">{modelNumber}</Typography>
        )} */}
        </Typography>
    );
};

export default ProductDescription;
